import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { saveState, loadState, removeState } from "../browser-storage/browser-storage";

type InitialState = {
  balanceCredit: number
}
const type = 'balanceCredit'

const initialState: InitialState = {
  balanceCredit: loadState(type)
}

export const balanceSliceCredit = createSlice({
  name: type,
  initialState: initialState,
  reducers: {
    setBalanceCredit: (state, action: PayloadAction<number>) => {
      state.balanceCredit = action.payload;
      saveState(type, action.payload)
    },
    removeBalanceCredit: (state) => {
      state.balanceCredit = 0;
      removeState(type)
    },
  },
});

// Action creators are generated for each case reducer function
export const { setBalanceCredit, removeBalanceCredit } = balanceSliceCredit.actions;

export default balanceSliceCredit.reducer;
